import { CardMedia, css, styled } from '@mui/material';

import { SNativeVideoPlayerProps } from './types';

export const SNativeVideoPlayer = styled(CardMedia)<SNativeVideoPlayerProps>(
  () => css`
    border-radius: 12px;
  `,
);
